import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cc66bcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottom" }


const __default__ = { name: 'bottom' }

export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {

const list = [
  '@2015 hxzs.com.cn',
  '舟山海星轮船有限公司',
  '浙ICP备05068861号',
  '版本号:1.13.34.32064'
]

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
      return _createElementVNode("span", {
        key: index,
        class: _normalizeClass(["item", { border: index !== list.length - 1 }])
      }, _toDisplayString(item), 3)
    }), 64))
  ]))
}
}

})